var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnContentsPlay = function SvgBtnContentsPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 39,
    fill: "#000",
    fillOpacity: 0.5,
    stroke: "#fff",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.625 43.051c1.5.866 1.5 3.032 0 3.898l-17.25 9.959c-1.5.866-3.375-.217-3.375-1.949V35.041c0-1.732 1.875-2.815 3.375-1.949l17.25 9.96Z",
    fill: "#fff"
  })));
};
export default SvgBtnContentsPlay;